function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};


// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepTripCancellationCFDataMapper.js